import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import app from '../../main' // import the instance
import checkResponse from '@/utils/checkResponse'
import parserSlug from '@/utils/parserSlug'

Vue.use(Vuex)

const state = {
  stats_to_quote: {},
  stats_quoted: {},
  stats_cancelled: {},
  stats_in_order: {},
  stats_finished: {},
  amount_due: {
    in_order: 0,
    finished: 0
  },
  customersDashboard: [],
  selectedCustomerIdDashboard: undefined,
  pagination: {
    currentPage: 1,
    perPage: 5,
    totalCustomers: 0,
    totalPages: 0
  },
  projectsDashboard: {
    to_quote: [],
    quoted: [],
    cancelled: []
  }
}

const mutations = {
  SET_DASHBOARD_STATS (state, payload) {
    state.stats_to_quote = payload.to_quote
    state.stats_quoted = payload.quoted
    state.stats_in_order = payload.in_order
    state.stats_cancelled = payload.cancelled
    state.stats_finished = payload.finished
    state.amount_due.in_order = payload.amount_due.in_order
    state.amount_due.finished = payload.amount_due.finished
  },
  SET_CUSTOMERS_DASHBOARD (state, payload) {
    payload.data.forEach(e => {
      state.customersDashboard.push(e)
    })

    state.pagination = {
      currentPage: payload.current_page,
      perPage: payload.per_page,
      totalCustomers: payload.total,
      totalPages: payload.last_page
    }
  },
  SET_CUSTOMER_ID_DASHBOARD (state, payload) {
    state.selectedCustomerIdDashboard = payload.customer_id
  },

  SET_PROJECTS_DASHBOARD (state, payload) {
    state.projectsDashboard.to_quote = payload.to_quote
    state.projectsDashboard.quoted = payload.quoted
    state.projectsDashboard.cancelled = payload.cancelled
  },
  SET_CATALOG (state, { object, payload }) {
    state.customersDashboard = payload.data
  },
  CLEAN_LISTS (state) {
    state.projectsDashboard.to_quote = []
    state.projectsDashboard.quoted = []
    state.projectsDashboard.cancelled = []
    state.customersDashboard = []
  },
  CLEAN_PROJECTS (state) {
    state.projectsDashboard.to_quote = []
    state.projectsDashboard.quoted = []
    state.projectsDashboard.cancelled = []
  }
}

const actions = {
  async loadCustomersDashboard ({ commit }, payload) {
    try {
      const response = await axios.get(`customers?page=1`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_CUSTOMERS_DASHBOARD', response.data)
      }
    } catch (e) {
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    }
  },

  async loadProjectsDashboard ({ commit }, payload) {
    try {
      const response = await axios.get(`dashboard/projects`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_PROJECTS_DASHBOARD', response.data)
      }
    } catch (e) {
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
    }
  },
  async loadDashboard ({ commit }, payload) {
    app.$Progress.start()
    try {
      const res = await axios.get(`/dashboard/stats`)
      const checkErrors = checkResponse(res)
      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_DASHBOARD_STATS', res.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async loadProjectsCustomerDashboard ({ commit }, payload) {
    try {
      const response = await axios.get(`dashboard/customer/${payload.customer_id}/projects`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_PROJECTS_DASHBOARD', response.data)
      }
    } catch (e) {
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
    }
  },
  async loadCustomerDashboard ({ commit }, payload) {
    app.$Progress.start()
    try {
      const res = await axios.get(`/dashboard/customer/${payload.customer_id}/stats`)
      const checkErrors = checkResponse(res)
      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_DASHBOARD_STATS', res.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async loadCatalog ({ commit }, payload) {
    let url = parserSlug(payload.url)
    try {
      const response = await axios.get(`${url}${payload.filter}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'strings.quotations', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_CATALOG', { object: payload.url, payload: response.data })
      }
    } catch (e) {
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    }
  },
  setCustomerIdDashboard ({ commit }, payload) {
    commit('SET_CUSTOMER_ID_DASHBOARD', payload)
    commit('SET_CUSTOMER_ID_DASHBOARD', payload)
  },
  clearLists ({ commit }) {
    commit('CLEAN_LISTS', null)
  },
  clearProjects ({ commit }) {
    commit('CLEAN_PROJECTS', null)
  }
}

const getters = {
  customersDashboard: state => state.customersDashboard,
  selectedCustomerIdDashboard: state => state.selectedCustomerIdDashboard,
  pagination: state => state.pagination,
  stats_to_quote: state => state.stats_to_quote,
  stats_quoted: state => state.stats_quoted,
  stats_cancelled: state => state.stats_cancelled,
  stats_in_order: state => state.stats_in_order,
  stats_finished: state => state.stats_finished,
  amount_due: state => state.amount_due,
  projectsDashboard: state => state.projectsDashboard
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
